<template>
  <div
    v-bind="$attrs"
    class="text-center"
  >
    <img
      :src="getFullSizeImage(file)"
      style="max-width: 100%;"
      class="checkerboard"
    />
  </div>

  <portal to="file-storage">
    <detail-item
      v-if="file.dimensions && Object.keys(file.dimensions).length > 0"
      large
      name="Dimensions"
      icon="mdi-arrow-split-horizontal"
    >
      {{ file.dimensions.width }}px (width) x {{ file.dimensions.height }}px (height)
    </detail-item>
  </portal>
</template>

<script>
import typeMixin from './mixin'
import fileMixin from '../../mixins/fileMixin'

export default {
  mixins: [typeMixin, fileMixin]
}
</script>
